import { Typography, Button, Row, Image } from "antd";
import homepageCreator1 from "../../assets/images/homepage-creator1.webp";
import homepageCreator2 from "../../assets/images/homepage-creator2.webp";
import homepageCreator3 from "../../assets/images/homepage-creator3.webp";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const { Title, Paragraph } = Typography;

const HomePageCreatorSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cardArr = [homepageCreator3, homepageCreator1, homepageCreator2];

  return (
    <Row className="peoples_main" justify="center">
      <div className="peoples-container">
        <div className="peoples-header">
          <div className="peoples-title"> {t("they-are-already-taking-advantage-of-it-text")}</div>
          <Paragraph className="peoples-subtitle">{t("they-tried-they-conerted-text")}</Paragraph>
          <Button className="peoples-button" type="primary" onClick={() => navigate("/auth/intro")}>
            {t("to-start-up")}
          </Button>
        </div>
        <div className="peoples-images">
          {cardArr.map((item, index) => (
            <Link to={"/auth/intro"}>
              {" "}
              <Image
                src={item}
                key={index}
                preview={false}
                alt={`User ${index + 1}`}
                className={`peoples-image ${index !== 1 ? "image-padding" : ""}`}
              />
            </Link>
          ))}
        </div>
      </div>
    </Row>
  );
};

export default HomePageCreatorSection;
